// ** Next Import
import { Link } from 'react-router-dom'

// ** MUI Imports
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { styled, useTheme } from '@mui/material/styles'

// ** Configs
import themeConfig from 'src/configs/themeConfig'
import { Box } from '@mui/material'
import { useAuth } from 'src/hooks/useAuth'
import UserDropdown from '../shared-components/UserDropdown'
import Translations from 'src/layouts/components/Translations'

const StyledLink = styled('a')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  marginRight: theme.spacing(8)
}))

const BlankLayoutAppBar = () => {
  // ** Hooks
  const theme = useTheme()
  const { user } = useAuth()

  return (
    <AppBar elevation={3} color='default' sx={{ padding: '30px' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex' }}>
          <Typography fontSize='24px' color='#000000' fontWeight={700}>
            <Translations text={`Hello, `} />
            <span style={{ color: '#FC5722' }}>
              {user?.firstName} {user?.lastName}
            </span>
            <span style={{ color: '#000' }}>
              {user?.firstName} {user?.lastName}
            </span>
          </Typography>
        </Box>
        <UserDropdown />
      </Box>
    </AppBar>
  )
}

export default BlankLayoutAppBar
